var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-slate-50 min-h-screen flex flex-col"},[_c('TheHeader'),_vm._v(" "),_c('MobileHeader'),_vm._v(" "),_c('div',{staticClass:"container mx-auto max-w-screen-xl px-5 grow flex flex-col items-stretch"},[_c('Nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }